module.exports = __webpack_public_path__ + "img/btn-big1.a585be0.png";